import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const CustomLoadingCellRenderer = ()=>{
    return /*#__PURE__*/ _jsx("div", {
        className: "ag-custom-loading-cell"
    });
};
CustomLoadingCellRenderer.displayName = 'CustomLoadingCellRenderer';
export { CustomLoadingCellRenderer };
